import { Card, Select, Button, ConfigProvider } from "antd";
import React, { useEffect, useState } from "react";
import loginbg from './picture/loginbg.png';
import R from './picture/R.png'
import { Form } from "antd"; // Import Form from antd, not react-router-dom
import { AboutResearchInterface } from "../models/IAboutResearch";
import { useLocation } from "react-router-dom";

export function SelectRole() {
    const data = JSON.parse(sessionStorage.getItem('POS_ID') || "[]");
    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState("");
    const location = useLocation();

    const handleFinish = (values: any) => {
        sessionStorage.setItem('IsMultiplePos','no')
        sessionStorage.setItem('Fac_ID',selected)
        window.location.reload();
    };

    useEffect(() => {
        // Map data to Select component's options structure
        const departmentOptions = data.map((item: any) => ({
            label: item.Fac_NameTH,
            value: item.Fac_ID,
        }));

        setOptions(departmentOptions);
    }, []);

    useEffect(() => {

        const setFavicon = (iconUrl: string) => {
          const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
          if (link) {
            link.href = iconUrl;
          } else {
            const newLink = document.createElement("link");
            newLink.rel = "icon";
            newLink.href = iconUrl;
            document.head.appendChild(newLink);
          }
        };
    
        // Set external image URL as favicon
        setFavicon("https://www.vu.ac.th/wp-content/uploads/elementor/thumbs/vu-main-logo-02-qtm90eapvkc9aj8bjqi1ltncwx61v3ygsveunoi0mu.png");
        document.title = "VRIIS"; 
        
         
      }, [location.pathname]);

    return (
        <ConfigProvider
            theme={{
                components: {
                    Form: { labelColor: 'white' },
                    Segmented: {
                        itemActiveBg: '#D4BDAC',
                        itemSelectedBg: '#FFF1DB',
                        trackBg: 'gray',
                        itemColor: 'white',
                    },
                },
                token: { fontFamily: 'Chakra Petch' },
            }}
        >
            <title>VRIIS</title>
            <div
                className="bg-slategray"
                style={{
                    height: '100vh',
                    width: '100vw',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundImage: `url(${R})`,
                    backgroundSize: '100% 100%', 
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                }}
            >
                <Card
                    bordered={false}
                    style={{
                        width: 500,
                        textAlign: 'center',
                        backgroundColor:'#DED4F2',
                        borderRadius: 8,
                    }}
                >
                    <Form 
                        onFinish={handleFinish}
                        layout="vertical" // Optional: Change layout to vertical
                    >
                        <p className='font-semibold text-xl' style={{color:'#6f62ae'}}>โปรดเลือกสังกัดที่ท่านต้องการใช้ในการเข้าสู่ระบบ</p>
                        <Form.Item>
                            <Select
                                size='large'
                                className='text-xl'
                                style={{ marginTop: 20, width: '100%' }}
                                options={options}
                                placeholder="โปรดเลือกสังกัด"
                                onChange={(value) => setSelected(value)} // Capture selected value
                            />
                        </Form.Item> {/* Corrected from Form.item to Form.Item */}
                        <Button type="primary" size='large' style={{width:350,color:'white',backgroundColor:'#6d62ae'}} htmlType="submit">
                            <p className='text-xl'>เลือก</p>
                        </Button>
                    </Form>
                </Card>
            </div>
        </ConfigProvider>
    );
}
